<template>
  <v-row>
    <v-col>
      <v-row>
        <v-spacer></v-spacer>
        <v-col class="pa-0 pt-4 ma-0" cols="12" sm="3">
          <v-text-field
            :autocomplete="autocompleteValueLocal"
            class="mr-3 to-upper"
            :label="$t('schedulestab.search')"
            @input="debounceInput"
            prepend-icon="mdi-magnify"
            v-bind:clearable="true"
            clear-icon="mdi-close"
            v-model="search"
            :outlined="is_boxes"
            :dense="is_boxes"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-data-table
          :footer-props="{
            'items-per-page-options': dataTableOptions,
          }"
          fixed-header
          :headers="headers"
          :options="options"
          :server-items-length="totalItems"
          :loading="isLoading"
          :loading-text="this.$t('loading')"
          class="elevation-0"
          style="width: 100%"
          :height="'calc(-600px + 100vh)'"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items-per-page="itemsPerPage"
          item-key="identifier"
          @update:sort-by="updateSort"
          @update:sort-desc="updateSortOrder"
          @update:page="updatePagination"
          @update:items-per-page="updateItemsPerPage"
          :items="applications"
          must-sort
        >
          <template v-slot:item="{ item }">
            <tr :class="setRowColorClass(item)">
              <!-- Name -->
              <td>
                <strong>
                  {{ item?.towing_partner?.full_name }}
                </strong>
                <template>
                  <br />
                  {{ item?.towing_partner?.company?.name }}
                </template>
              </td>
              <!-- Registration Number -->
              <td>
                {{ item?.vehicle?.registration_number }}
              </td>
              <!-- Applied At -->
              <td>
                {{ item.created_at }}
              </td>
              <!-- Accepted At -->
              <td>
                {{ item.accepted_at }}
              </td>
              <!-- Cancelled At -->
              <td>
                {{ item.cancelled_at }}
              </td>
              <!-- Status -->
              <td>
                {{ $t("mission.statuses." + item?.status?.key) }}
              </td>
              <!-- Actions -->
              <td>
                <v-tooltip bottom v-if="item?.status?.key != 'selected'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="primary"
                      @click="confirmSelectPopUp(item, 'select_applicant')"
                      icon
                    >
                      <!-- {{ $t("mission.select") }} -->
                      <v-icon dark> mdi-check </v-icon>
                    </v-btn>
                  </template>
                  {{ $t("mission.select") }}
                </v-tooltip>
                <v-tooltip bottom v-if="item?.status?.key == 'selected'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="primary"
                      @click="confirmSelectPopUp(item, 'reject_applicant')"
                      icon
                    >
                      <v-icon dark> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  {{ $t("mission.reject") }}
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-row>
    </v-col>

    <confirmation-model
      v-if="confirmationDialog"
      :showDialog.sync="confirmationDialog"
      :openedForOperation.sync="confirmationDialogOperation"
      :text.sync="confirmationDialogConfirmationText"
      :trueText.sync="confirmationDialogTrueText"
      :falseText.sync="confirmationDialogFalseText"
      @buttonClicked="confirmationButtonClicked"
    ></confirmation-model>
  </v-row>
</template>
<script>
import axios from "@/plugins/axios";
import _ from "lodash";
import { API_BASE_URL } from "@/config";
import { DEFAULT_ITEMS_PER_PAGE_OPTIONS } from "@/config";
import ConfirmationModel from "@/components/ConfirmationModel";

export default {
  components: {
    ConfirmationModel,
  },
  props: {
    mission: [Object],
  },
  data() {
    return {
      is_boxes: this.getCompanyPropertyFromLocalStorage("boxes_on_fields", 1),
      dataTableOptions: DEFAULT_ITEMS_PER_PAGE_OPTIONS,
      applications: [],
      alerts: [],
      search: "",
      isLoading: true,
      totalItems: 0,
      page: 1,
      lastPage: 1,
      itemsPerPage: DEFAULT_ITEMS_PER_PAGE_OPTIONS[0],
      options: {},
      sortBy: "title",
      sortDesc: false,
      sortOrd: "ASC",
      sort: {},
      token: this.$store.state.AccessToken,
      header: { Authorization: "Bearer " + this.$store.state.AccessToken },
      autocompleteValueLocal: "off",
      isDebounceCancelled: false,
      selectItemForPopUp: null,
      missionApplicationStatuses: [],

      confirmationDialog: false,
      confirmationDialogConfirmationText: null,
      confirmationDialogFalseText: null,
      confirmationDialogTrueText: null,
      confirmationDialogButtonClickedIs: null,
      confirmationDialogOperation: null,
      confirmationDialogData: null,
    };
  },

  created() {
    (this.header = { Authorization: "Bearer " + this.token }), this.fetchData();
    this.autocompleteValueLocal = this.autocompleteValue();
    this.getApplicationStatuses();
  },
  methods: {
    setRowColorClass(item, applyBackground = false) {
      let className = "";
      console.log("status", item?.status?.key ?? item?.key);
      let status_key = item?.status?.key ?? item?.key;

      if (status_key == "selected") {
        className = "greenColor";
      }

      if (status_key == "accepted_by_towing_partner") {
        className = "greenColor";
      }

      if (
        status_key == "cancelled_by_towing_partner" ||
        status_key == "rejected"
      ) {
        className = "redColor";
      }

      if (applyBackground) {
        return className + "Background";
      }

      return className;
    },
    async getApplicationStatuses() {
      await this.getCodes(
        "mission_application_statuses",
        "mission.statuses"
      ).then((data) => {
        this.missionApplicationStatuses = data;
      });
    },
    confirmSelectPopUp(item, operation = "") {
      this.selectItemForPopUp = item;
      console.log("selected item", item);
      if (this.selectItemForPopUp) {
        this.$nextTick(() => {
          this.confirmationDialogConfirmationText =
            operation == "select_applicant"
              ? this.$t("mission.text_messages.are_you_sure_you_want_to_select")
              : this.$t(
                  "mission.text_messages.are_you_sure_you_want_to_reject"
                );
          this.confirmationDialogFalseText = this.$t("no");
          this.confirmationDialogTrueText = this.$t("yes");
          this.confirmationDialogOperation = operation;
          this.confirmationDialog = true;
        });
      }
    },
    confirmationButtonClicked(buttonClicked) {
      this.confirmationDialogButtonClickedIs = buttonClicked;
      this.confirmationDialog = false;
    },
    debounceInput: _.debounce(function () {
      if (this.isDebounceCancelled) {
        this.isDebounceCancelled = false;
        return false;
      }
      this.fetchData();
    }, 500),
    fetchData() {
      this.isLoading = true;
      axios({
        method: "get",
        url: API_BASE_URL + "/missions/applications/" + this.mission.id,
        headers: this.header,
      })
        .then((response) => {
          this.applications = response.data.data;
          this.totalItems = response.data.data.length;
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.success(
            this.$t("schedulestab.something_went_wrong_while_fetching_data")
          );
        });
    },
    updatePagination(page) {
      this.page = page;
      this.fetchData();
    },
    updateItemsPerPage(itemsPerPage) {
      itemsPerPage == -1
        ? (this.itemsPerPage = this.totalItems)
        : (this.itemsPerPage = itemsPerPage);
      this.fetchData();
    },
    updateSort(sortBy) {
      if (typeof sortBy == "object") {
        this.sortBy = sortBy[0];
      } else {
        this.sortBy = sortBy;
      }
      this.fetchData();
    },
    updateSortOrder(sortDesc) {
      if (typeof sortDesc == "object") {
        !sortDesc[0] ? (this.sortOrd = "ASC") : (this.sortOrd = "DESC");
      } else {
        !sortDesc ? (this.sortOrd = "ASC") : (this.sortOrd = "DESC");
      }
      this.fetchData();
    },
    selectApplicant() {
      let selectedCodeId = null;
      this.missionApplicationStatuses.forEach((element) => {
        if (element.key == "selected") {
          selectedCodeId = element.id;
        }
      });
      let data = {
        status_id: selectedCodeId,
      };
      axios
        .put(
          API_BASE_URL +
            "/missions/applications/" +
            this.selectItemForPopUp?.id,
          data,
          {
            headers: this.header,
          }
        )
        .then(({ data }) => {
          this.$emit("application-data", data.data);
        })
        .catch(() => {})
        .finally(() => {
          this.fetchData();
        });
    },
    rejectApplicant() {
      let selectedCodeId = null;
      this.missionApplicationStatuses.forEach((element) => {
        if (element.key == "rejected") {
          selectedCodeId = element.id;
        }
      });
      let data = {
        status_id: selectedCodeId,
      };
      axios
        .put(
          API_BASE_URL +
            "/missions/applications/" +
            this.selectItemForPopUp?.id,
          data,
          {
            headers: this.header,
          }
        )
        .then(({ data }) => {
          this.$emit("application-data", data.data);
        })
        .catch(() => {})
        .finally(() => {
          this.fetchData();
        });
    },
  },
  watch: {
    confirmationDialogButtonClickedIs(newVal) {
      if (newVal == true && this.confirmationDialogOperation != null) {
        if (
          this.confirmationDialogOperation == "select_applicant" &&
          this.confirmationDialogButtonClickedIs == true
        ) {
          this.selectApplicant();
        }
        if (
          this.confirmationDialogOperation == "reject_applicant" &&
          this.confirmationDialogButtonClickedIs == true
        ) {
          this.rejectApplicant();
        }
        this.confirmationDialog = false;
        this.confirmationDialogButtonClickedIs = null;
      }
    },
  },
  computed: {
    headers() {
      return [
        { text: this.$t("mission.applicant"), value: "applicant" },
        { text: this.$t("mission.vehicle"), value: "vehicle" },
        { text: this.$t("mission.applied_at"), value: "applied_at" },
        { text: this.$t("mission.accepted_at"), value: "accepted_at" },
        { text: this.$t("mission.cancelled_at"), value: "cancelled_at" },
        { text: this.$t("mission.status"), value: "status" },
        { text: this.$t("mission.actions"), value: "id", width: "150px" },
      ];
    },
  },
};
</script>
<style scoped></style>
